import styled from 'styled-components';
import { ThemeProps } from '@/styles/global';
import { StylesProps } from '@/utils/stylesProps';

type Props = ThemeProps & StylesProps;

export const Container = styled.div`
  min-height: calc(100vh - 5rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props: ThemeProps) => props.theme.backgroundColor};
  padding: 0 7.5rem;
  min-width: 18.75rem;
  @media (min-width: 769px) and (max-width: 992px) {
    padding: 0 2.5rem;
  }
  @media (max-width: 768px) {
    min-height: calc(100vh - 4.5rem);
    padding: 0;
  }
`;

export const Title = styled.h1`
  position: relative;
  margin: 3rem 0 0.75rem;
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 3.25rem;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  text-align: center;
  & img {
    position: absolute;
    bottom: 0.375rem;
    right: -2.3rem;
  }
  @media (max-width: 768px) {
    margin: 1rem 1rem 0.75rem 1rem;
    font-size: 1.25rem;
  }
`;

export const Subtitle = styled.h3`
  margin: 0.75rem 0 1.25rem;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  text-align: center;
  @media (max-width: 768px) {
    margin: 0.5rem 1rem 1.25rem 1rem;
    font-size: 1.125rem;
  }
`;

export const StepsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 40.875rem;
  height: 3.5rem;
  margin: 1.25rem 0 1.25rem;
  @media (max-width: 768px) {
    width: 100%;
    height: 3rem;
    margin: 1.25rem 0 1.25rem;
    padding: 0 0.5rem;
  }
`;

export const StepsDiv = styled.div`
  position: relative;
  padding: 1.1rem 1.5rem;
  width: 13.125rem;
  height: 100%;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.3125rem;
  background-color: ${(props: Props) =>
    props.isReady ? props.theme.softGreenColor : props.theme.whiteColor};
  border: 0.0625rem solid
    ${(props) => (props.isCurrentStep ? props.theme.softGreenColor : `#d2d6dc`)};
  border-left: none;
  border-radius: 0.25rem;
  box-shadow: 0 0.0625rem 0.125rem rgba(55, 65, 81, 0.08);
  color: ${(props: Props) =>
    props.isReady
      ? props.theme.whiteColor
      : props.isCurrentStep
      ? props.theme.softGreenColor
      : props.theme.blackColor};
  & div {
    border-color: ${(props: Props) =>
      props.isCurrentStep ? props.theme.softGreenColor : `#d2d6dc`} !important;
    background-color: ${(props: Props) =>
      props.isReady
        ? props.theme.softGreenColor
        : props.theme.whiteColor} !important;
  }
  &:first-child {
    border-left: 0.0625rem solid
      ${(props: Props) =>
        props.isCurrentStep ? props.theme.softGreenColor : `#d2d6dc`};
  }
  @media (max-width: 768px) {
    width: ${(props: Props) => (props.isCurrentStep ? `70%` : `15%`)};
    margin: 0 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const ButtonWrapper = styled.div`
  width: 14.8125rem;
  height: 3.5rem;
  @media (max-width: 768px) {
    height: 3rem;
  }
`;

export const StyledDivWrapper = styled.div`
  display: flex;
  align-items: center;
  height: calc(100vh - 5rem);
  background-color: ${(props: ThemeProps) => props.theme.backgroundColor};
  padding: 0 7.5rem;
  min-width: 18.75rem;
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 35rem;
  margin: 0 auto;
  & h1 {
    margin-top: 1rem;
  }
`;

export const Arrow = styled.div`
  position: absolute;
  z-index: 2;
  right: -0.9375rem;
  top: 0.625rem;
  width: 2.125rem;
  height: 2.125rem;
  border-radius: 0.3125rem;
  border: 0.0625rem solid transparent;
  clip-path: polygon(100% 100%, 100% 0%, 0% 0%, 0% 0%);
  transform: rotate(45deg) skew(15deg, 15deg);
  @media (max-width: 768px) {
    right: -0.8rem;
    top: 0.5rem;
    width: 1.85rem;
    height: 1.85rem;
  }
`;

export const BackArrow = styled.div`
  & div {
    position: absolute;
    z-index: 1;
    border: 0.0625rem solid
      ${(props: Props) =>
        props.isCurrentStep ? props.theme.softGreenColor : `#d2d6dc`};
    clip-path: polygon(100% 100%, 100% 0%, 0% 0%, 0% 0%);
  }
  & div:first-child,
  & div:last-child {
    left: -0.125rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 0.3125rem;
    background-color: ${(props: Props) =>
      props.isReady ? props.theme.softGreenColor : props.theme.whiteColor};
  }
  & div:first-child {
    top: 0;
    transform: rotate(-115deg) skew(15deg, 15deg);
  }
  & div:last-child {
    bottom: 0;
    transform: rotate(-155deg) skew(15deg, 15deg);
  }
  & div:nth-child(2) {
    left: -0.8125rem;
    top: 0.9375rem;
    width: 1.5rem;
    height: 1.5rem;
    border-top-right-radius: 0.3125rem;
    background-color: ${(props: ThemeProps) =>
      props.theme.backgroundColor} !important;
    transform: rotate(45deg) skew(15deg, 15deg);
    @media (max-width: 768px) {
      left: -0.7rem;
      top: 0.8rem;
      width: 1.28rem;
      height: 1.28rem;
    }
  }
`;
